import type { UserWithMeta } from '~/@biz_account/useUser/types'

function getPersonalInfoItems(
  userProfile: UserWithMeta['profile'] | undefined,
  country: string | undefined
) {
  if (userProfile == null) return []

  return [
    { label: 'Užívateľské meno:', value: userProfile.email },
    { label: 'Meno:', value: userProfile.firstname },
    { label: 'Priezvisko:', value: userProfile.lastname },
    {
      label: 'Ulica a číslo:',
      value: [userProfile.address?.street, userProfile.address?.number]
        .filter(Boolean)
        .join('\xa0'),
    },
    { label: 'Mesto:', value: userProfile.address?.city ?? '' },
    { label: 'PSČ:', value: userProfile.address?.zip ?? '' },
    {
      label: 'Krajina:',
      value: country,
    },
  ]
}

export { getPersonalInfoItems }
